import { schema } from "normalizr";
import { LinesheetLinkSchema } from "./linesheet-link";

export const LinesheetLinksSchema = new schema.Array(LinesheetLinkSchema);
